import {enableProdMode} from '@angular/core';
import {bootstrapApplication} from "@angular/platform-browser";
import {
    AppInfoService, AuthGuardService, AuthService, ScreenService, ThemeService
} from "@services";
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {AuthInterceptor} from './app/interceptors/auth.interceptor';
import {provideRouter, withHashLocation} from "@angular/router";

import themes from 'devextreme/ui/themes';
import {AppComponent} from './app/app.component';
import {environment} from './environments/environment';
import {routes} from "./app/app-routes";
import {DATE_PIPE_DEFAULT_OPTIONS, DatePipeConfig} from "@angular/common";

if (environment.production) {
    enableProdMode();
}

themes.initialized(() => {
    bootstrapApplication(AppComponent, {
        providers: [
            AuthService,
            ScreenService,
            AppInfoService,
            ThemeService,
            AuthGuardService,
            provideHttpClient(withInterceptorsFromDi()),
            provideRouter(routes, withHashLocation()),
            {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
            {
                provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: {
                    dateFormat: 'dd-MM-yyyy'
                } as DatePipeConfig
            }
        ]
    }).catch(e => console.error(e));
});

